module.exports = __webpack_public_path__ + "img/rugby-ball.b0e14c31.svg";